import { matchPattern } from '@americanexpress/one-app-router/lib/PatternUtils';

export const ROUTE_LOCALE_PATTERN = ':locale/account(/*)/login';
export const matchLocaleFromRoute = (pathname) => {
  try {
    let locale = null;
    const matched = matchPattern(ROUTE_LOCALE_PATTERN, pathname);
    if (matched) {
      const { paramNames, paramValues } = matched;
      const params = paramNames.reduce(
        (accum, name, index) => ({ ...accum, [name]: paramValues?.[index] }),
        {}
      );

      locale = params.locale;
    }

    return locale;
  } catch (error) {
    return error;
  }
};
